module.exports = __webpack_public_path__ + "img/460a.28934c51.png";